import { render, staticRenderFns } from "./resultValuation.vue?vue&type=template&id=79a8908b&scoped=true&"
import script from "./resultValuation.vue?vue&type=script&lang=js&"
export * from "./resultValuation.vue?vue&type=script&lang=js&"
import style0 from "./resultValuation.vue?vue&type=style&index=0&id=79a8908b&prod&scoped=true&lang=scss&"
import style1 from "./resultValuation.vue?vue&type=style&index=1&id=79a8908b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a8908b",
  null
  
)

export default component.exports